<template>
  <div>
    <div class="columns is-multiline">
      <!-- 옵션 템플릿 목록 -->
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="옵션 템플릿 목록" :useTab="false">
            <ul>
              <li v-for="(item, idx) in tableItems">
                <div class="lp-option-item">
                  <div>{{ item.name }}</div>
                  <div style="flex:1"></div>
                  <button class="button half" @click="selOption(item)" style="margin-right:4px" v-if="item.id>0">수정</button>
                  <button class="button half is-danger" @click="delOption(tableItems, idx)">삭제</button>
                  <i class="material-icons"
                     style="margin-left: 6px"
                     @click="item.selected = !item.selected">keyboard_arrow_{{ item.selected ? 'up' : 'down' }}</i>
                </div>
                <div style="padding:0.75rem">
                  <div class="columns" v-if="item.selected"
                    v-for="option in item.options" :key="option.name">
                    <div class="column">
                      <admin-form-item label="옵션값">
                        <input class="input"
                               :value="option.name"
                               :disabled="true"
                               type="text" maxlength="20">
                      </admin-form-item>
                    </div>
                    <div class="column">
                      <admin-form-item label="옵션가격">
                        <div class="flex">
                          <input class="input"
                                 :value="option.price"
                                 :disabled="true"
                                 type="number" maxlength="20">
                          <div class="flex space-between align-center">
                            <div style="margin-left:3px">원</div>
                          </div>
                        </div>
                      </admin-form-item>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="btn-add-option" @click="addOption">옵션 추가하기</div>
          </admin-box-item>
        </div>
      </div>

      <!-- 옵션 추가/수정 -->
      <div class="column is-6" v-if="visible_option">
        <div class="box">
          <admin-box-item title="옵션 추가/수정" :useTab="false">
            <div v-if="section===1">
              <admin-form-item label="옵션 템플릿 선택">
                <span class="select">
                    <select @change="selectOptionTemplate">
                        <option value="" disabled selected>옵션 템플릿 선택</option>
                        <option v-for="option in optionTemplateArr"
                                :value="option.value">{{ option.label }}</option>
                      </select>
                </span>
              </admin-form-item>
            </div>
            <div v-if="section===2">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="옵션 선택">
                    <div>{{ product_selector.name }}</div>
                  </admin-form-item>
                </div>
                <div class="column is-7">
                  <admin-form-item label="옵션명">
                    <input class="input"
                           :value="product_selector.name"
                           @input="e => product_selector.name = e.target.value"
                           type="text" maxlength="30">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="옵션 종류">
                    <lp-radio @onSelect="setOptionType"
                              value_name="value"
                              label_name="label"
                              :val.sync="product_selector.option_type"
                              :data="optionType"
                              :block="true"></lp-radio>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품옵션 기본값 여부">
                    <lp-check-bool :checked-val.sync="product_selector.required"
                                   label="상품 등록 시 기본 옵션으로 설정되게 합니다."></lp-check-bool>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <div class="columns is-multiline" v-for="(option, idx) in product_selector.options" :key="`selector-${idx}`">
                    <div class="column is-6">
                      <admin-form-item label="옵션값">
                        <input class="input"
                               :value="option.name"
                               @input="e => option.name = e.target.value"
                               type="text" maxlength="20">
                      </admin-form-item>
                    </div>
                    <div class="column ia-6">
                      <admin-form-item label="옵션가격">
                        <div class="flex">
                          <input class="input"
                                 v-model.number="option.price"
                                 type="number" maxlength="20">
                          <div class="flex space-between align-center">
                            <div style="margin-left:3px">원</div>
                            <i class="material-icons"
                               @click="deleteOptionValue(idx)"
                               style="line-height: 32px;margin-left:12px">close</i>
                          </div>
                        </div>
                      </admin-form-item>
                    </div>
                    <div class="column is-12">
                      <admin-form-item label="grade" style="margin-bottom:16px"
                                       tip="플랜변경시 업그레이드,다운그레이드할때 사용함"
                                       v-if="product_selector.option_type===0">
                        <input class="input"
                               style="width:100px"
                               v-model="option.grade"
                               type="number">
                      </admin-form-item>
                      <admin-form-item label="결제 방식">
                        <lp-radio :val.sync="option.is_subscription"
                                  value_name="value"
                                  label_name="label"
                                  :data="[{label:'건 결제', value:false}, {label:'정기 결제',value:true}]"></lp-radio>
                        <div class="desc" v-if="option.is_subscription">* 판매가격으로 월단위 정기 결제됩니다.</div>
                        <div v-if="option.is_subscription" style="padding:16px 0 24px 0">
                          <button class="button is-primary" @click="clickAddSubscription(option)">결제 주기 추가</button>
                          <div class="flex-align" v-for="(item,idx) in option.subscriptions" :key="'subscription-'+idx"
                               style="margin-top:8px">
                            <div style="margin-right:4px">주기</div>
                            <input type="number" v-model="item.date_unit" style="width:40px">
                            <!--<div style="margin:0 4px 0 20px">월별 금액</div>
                            <input type="number" v-model="item.price"><div style="margin-left:4px">원</div>-->

                            <div style="margin-left:20px">
                              <lp-radio :val.sync="item.discount_type"
                                        value_name="value"
                                        label_name="label"
                                        :showInput="true"
                                        :block="true"
                                        @onSelect="res=> setSubscriptionValue(res, item, option)"
                                        @onEdit="res => setSubscriptionValue(res, item, option)"
                                        :data="[
                                        {label:'할인율', value:0, num: item.discount_rate, unit:'%'},
                                        {label:'할인액', value:1, num: item.price, unit:'원'}]"></lp-radio>
                            </div>
                            <i class="material-icons unselect" @click="clickDeleteSubs(option, idx)"
                               style="padding:2px;font-size:16px;margin-left:4px">close</i>
                          </div>
                        </div>
                      </admin-form-item>
                    </div>
                    <div class="column is-12">
                      <admin-form-item label="옵션 설명">
                        <textarea class="textarea"
                                  rows="4"
                                  cols="4"
                                  v-model="option.desc"></textarea>
                      </admin-form-item>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <button class="button is-grey" @click="addOptionValue">옵션값 추가</button>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="btn-group-justify-end">
          <button class="button" @click="cancel">취소</button>
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import LpRadio from "../../module/common/LpRadio";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";

  export default {
    name: 'LpProductOption',
    components: {
      LpAdmDropInput,
      LpCheckBool,
      LpRadio
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          this.getData();
        }
      }
    },
    data () {
      return {
        // 오른쪽 컬럼
        visible_option: false,
        // 1: 템플릿 선택 영역, 2: 옵션 추가, 선택 영역
        section:1,
        tableItems: [],
        product_selector: {
          id: 0,
          name: '',
          type: 0,
          options: [{
            name: '',
            price: ''
          }],
        },
        optionTemplateArr: [],
        optionType: [
          { label: '필수 선택 옵션', value:0, detail:'*상품 주문 시 반드시 선택해야 하는 상품 속성 성격의 옵션입니다.'},
          { label: '추가 옵션', value:1, detail:'*상품 주문 시 추가 주문할 수 있는 성격의 옵션입니다.'}
        ]
      }
    },
    created() {
      this.getData();
    },
    methods: {
      setSubscriptionValue(res, item, option) {
        if(res.hasOwnProperty('text')) {
          if(res.value===0) {
            item.discount_rate = parseInt(res.text);
            item.price = option.price - (option.price * item.discount_rate / 100)
          } else {
            item.price = parseInt(res.text);
          }
        } else {
          if(res===0) {
            item.price = option.price - (option.price * item.discount_rate / 100);
          }
        }
      },
      clickDeleteSubs(option,idx) {
        removeIndex(option.subscriptions, idx);
      },
      clickAddSubscription(option) {
        let opt = {
          date_unit: 3,
          price: 0,
          discount_type: 0,
          discount_rate: 0
        }
        if(option.subscriptions) {
          option.subscriptions.push(opt)
        } else {
          option.subscriptions = [opt]
        }
      },
      // 옵션 종류 선택
      setOptionType(res){
        this.product_selector.option_type = res.value;
      },
      deleteOptionValue(index){
        removeIndex(this.product_selector.options, index);
      },
      addOptionValue(){
        this.product_selector.options.push({
          name: '옵션',
          price: 0,
          desc: '',
          is_subscription: false,
          subscriptions: [],
          grade: 0
        })
      },
      // 옵션 추가하기
      addOption(){
        this.visible_option = true;
      },
      // 템플릿 수정
      selOption(item){
        this.visible_option = true;
        this.section=2;
        this.product_selector = this.cloneItem(item);
      },
      // 템플릿 삭제
      delOption(items, index){
        if (items[index].id) {
          let value = {
            id: items[index].id,
            url: 'product/selector/',
            title: '옵션 템플릿을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      // 옵션 템플릿 선택
      selectOptionTemplate(e){
        let val = Number(e.target.value);
        if(val === 0) {
          this.product_selector = {
            id: 0,
            name: '옵션명',
            option_type:0,
            type: 0,
            required:false,
            options: [
              {
                name: '옵션',
                price: 0,
                desc: '',
                is_subscription: false,
                subscriptions: [],
                grade: 0
              }
            ]
          }
        }
        else {
          let arr = this.optionTemplateArr.filter(i => i.id === val );
          if(arr.length>0) {
            this.product_selector = arr[0];
          }
        }
        this.section = 2;
      },
      cancel(){
        this.visible_option = false;
        this.section = 1;
      },
      saveData(){
        if(this.product_selector.id===0) {
          this.$axios.post(this.getUrl('product/selector'), this.product_selector).then(res => {
            if (res.status === 200) {
              this.visible_option = false;
              this.toast('저장되었습니다.');
              this.visible_option = false;
              this.section = 1;

              this.getData();
            }
          })
        }
        else {
          this.$axios.patch(this.getUrl('product/selector/'+this.product_selector.id), this.product_selector).then(res => {
            if (res.status === 200) {
              this.visible_option = false;
              this.toast('저장되었습니다.');
              this.visible_option = false;
              this.section = 1;

              this.getData();
            }
          })
        }
      },
      getData(){
        this.$axios.get(this.getUrl('product/selector')).then(res=>{
          this.tableItems = res.data;
          this.optionTemplateArr = [{ label: '새 옵션 추가', value: 0 }].concat(res.data);
        })
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-option-item
    font-size 0.9rem
    border 1px solid #ccc
    padding 8px
    display flex
    margin-bottom 8px
  .lp-option-item div
    margin auto 0
    margin-right 8px
  .lp-option-item div:last-child
    margin-right 0

  .btn-add-option
    padding 12px
    text-align center
    border 1px solid #ccc
    font-size 0.9rem
</style>
